/**
 * Drawer de navegación: abrir/cerrar con botón menú, overlay y Escape.
 * Re-inicializa iconos Lucide al abrir.
 */
(function () {
  var overlay = document.getElementById('edas-drawer-overlay');
  var toggle = document.querySelector('[data-edas-drawer-toggle]');
  var closeBtn = overlay ? overlay.querySelector('[data-edas-drawer-close]') : null;

  if (!overlay || !toggle) return;

  function isOpen() {
    return overlay.getAttribute('data-open') === 'true';
  }

  function open() {
    overlay.removeAttribute('hidden');
    overlay.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    if (window.lucide) {
      window.lucide.createIcons();
    }
  }

  function close() {
    overlay.setAttribute('data-open', 'false');
    overlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  function toggleDrawer() {
    if (isOpen()) {
      close();
    } else {
      open();
    }
  }

  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    toggleDrawer();
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      close();
    });
  }

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) {
      close();
    }
  });

  // Cerrar al hacer clic en un enlace del drawer (navegación)
  // overlay.querySelectorAll('.edas-drawer-item').forEach(function (link) {
  //   link.addEventListener('click', function () {
  //     close();
  //   });
  // });
})();
